export enum NumberFormats {
  NUMBER_FORMAT_COMMA = '1,234.56',
  NUMBER_FORMAT_POINT_COMMA = '1.234,56',
  NUMBER_FORMAT_APOSTROPHE_POINT = "1'234.56",
  NUMBER_FORMAT_SPACE_COMMA = '1 234,56',
}
